/* Sveikatos Taškas – krepšelio rezervacijos laikmatis. Privati sveikatostaskas.lt nuosavybė. */
if (!customElements.get('st-cart-timer')) {
  customElements.define('st-cart-timer', class extends HTMLElement {
    connectedCallback() {
      const minutes = parseFloat(this.dataset.minutes || '5');
      const key = 'stCartTimerEnd';
      let end = 0;
      try { end = parseInt(sessionStorage.getItem(key) || '0', 10); } catch (e) {}
      const now = Date.now();
      if (!end || end < now) {
        end = now + minutes * 60000;
        try { sessionStorage.setItem(key, String(end)); } catch (e) {}
      }
      this.end = end;
      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    tick() {
      let left = Math.max(0, Math.round((this.end - Date.now()) / 1000));
      if (left === 0) {
        const minutes = parseFloat(this.dataset.minutes || '5');
        this.end = Date.now() + minutes * 60000;
        try { sessionStorage.setItem('stCartTimerEnd', String(this.end)); } catch (e) {}
        left = Math.round(minutes * 60);
      }
      const m = String(Math.floor(left / 60)).padStart(2, '0');
      const s = String(left % 60).padStart(2, '0');
      const text = (this.dataset.text || '[timer]').replace('[timer]', '<strong>' + m + ':' + s + '</strong>');
      this.innerHTML = text;
    }
  });
}
